import { render } from "./DeleteWidgetModal.vue?vue&type=template&id=2cd4b1fb&ts=true"
import script from "./DeleteWidgetModal.vue?vue&type=script&lang=ts"
export * from "./DeleteWidgetModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__